import { ElementOptions } from './element.options';

export function element$<
  TElementOptions extends ElementOptions<HTMLElementTagNameMap[K]>,
  K extends keyof HTMLElementTagNameMap
>(
  tag: K,
  arg1?: TElementOptions | Element[] | string,
  arg2?: TElementOptions | Element[],
  arg3?: Element[]
): HTMLElementTagNameMap[K] {
  const element = document.createElement<K>(tag);
  let _children: Element[] | undefined;
  let _options: TElementOptions | undefined;
  let _class: string | undefined;

  if (Array.isArray(arg1)) {
    _children = arg1;
  } else if (typeof arg1 === 'string') {
    _class = arg1;
  } else if (arg1 !== undefined) {
    _options = arg1;
  }

  if (Array.isArray(arg2)) {
    _children = arg2;
  } else if (arg2 !== undefined) {
    _options = arg2;
  }

  if (Array.isArray(arg3)) {
    _children = arg3;
  }

  if (_class !== undefined) {
    element.className = _class;
  }

  if (_children !== undefined) {
    _children.forEach((child) => element.appendChild(child));
  }

  if (_options?.textContent !== undefined) {
    element.textContent = _options.textContent;
  }

  if (_options?.attributes !== undefined) {
    for (const key in _options.attributes) {
      const value = _options.attributes[key];

      element.setAttribute(key, value.toString());
    }
  }

  if (_options?.onCreate !== undefined) {
    _options?.onCreate(element);
  }

  return element;
}
